import {
  createEntityAdapter,
  createSlice,
  EntityId,
  EntityState,
  PayloadAction,
} from "@reduxjs/toolkit";
import { RecurringIssue } from "./types";
import {
  createRecurringIssue,
  deleteRecurringIssue,
  fetchRecurringIssues,
  updateRecurringIssue,
} from "./recurringIssueThunk";

export interface RecurringIssueState extends EntityState<RecurringIssue> {
  selectedId?: EntityId;
}

export const recurringIssueAdapter = createEntityAdapter<RecurringIssue>();

const initialState: RecurringIssueState = {
  ...recurringIssueAdapter.getInitialState(),
  selectedId: undefined,
};

const recurringIssueSlice = createSlice({
  name: "recurringIssues",
  initialState,
  reducers: {
    addRecurringIssue: recurringIssueAdapter.addOne,
    setRecurringIssues: recurringIssueAdapter.setAll,
    removeRecurringIssue: recurringIssueAdapter.removeOne,
    setRecurringIssue: recurringIssueAdapter.upsertOne,
    setSelectedRecurringIssueId(
      state,
      { payload }: PayloadAction<RecurringIssue["id"] | undefined>,
    ) {
      state.selectedId = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateRecurringIssue.fulfilled, (state, { payload }) => {
      recurringIssueAdapter.upsertOne(state, payload);
    });
    builder.addCase(deleteRecurringIssue.fulfilled, (state, { payload }) => {
      recurringIssueAdapter.removeOne(state, payload);
    });
    builder.addCase(createRecurringIssue.fulfilled, (state, { payload }) => {
      recurringIssueAdapter.addOne(state, payload);
    });
    builder.addCase(fetchRecurringIssues.fulfilled, (state, { payload }) => {
      recurringIssueAdapter.setAll(state, payload);
    });
  },
});

export const {
  addRecurringIssue,
  setRecurringIssues,
  removeRecurringIssue,
  setRecurringIssue,
  setSelectedRecurringIssueId,
} = recurringIssueSlice.actions;

export default recurringIssueSlice;
